import axios from "axios";
import APIURL from "../../../Main/apiurl";

const getAuthConfig = () => {
  const token = localStorage.getItem("user");
  if (!token) {
    localStorage.clear();
    window.location.href = "/";
    throw new Error("Authentication required");
  }
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

const get_all_accounts = async (acc) => {
  try {
    let data;

    if (acc?.source) {
      data = {
        search: acc?.search,
        source: acc?.source,
        isContra: acc?.isContra,
        isGetAll:acc?.isGetAll
      };
    } else {
      data = {
        search: acc?.search,
        page: acc?.page,
        limit: acc?.limit || 10,
        isGetAll:acc?.isGetAll
      };
    }

    const config = getAuthConfig();
    const response = await axios.post(
      `${APIURL}/get-all-accounts`,
      data,
      config
    );

    if (!response.data?.success) {
      throw new Error(response.data?.message || "Failed to fetch accounts");
    }

    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching accounts:", error.message);
    throw error;
  }
};

const create_account = async (accountData) => {
  try {
    const config = getAuthConfig();
    const response = await axios.post(
      `${APIURL}/create-account`,
      accountData,
      config
    );

    if (!response.data?.success) {
      throw new Error(response.data?.message || "Account creation failed");
    }

    return response.data;
  } catch (error) {
    console.error("Error creating account:", error.message);
    throw error;
  }
};

const update_balances_from_journal = async (entryId) => {
  try {
    const response = await axios.post("/api/update-balances-from-journal", {
      entryId,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating account balances:", error);
    throw error;
  }
};

export { create_account, get_all_accounts, update_balances_from_journal };
